import { Zap } from 'lucide-react';
import { GuideCategory } from './types';

export const visualCustomizationGuide: GuideCategory = {
  id: 'visual-customization',
  title: 'Visuals & Aesthetics',
  icon: Zap,
  articles: [
    {
      slug: 'backgrounds-parallax',
      title: 'Backgrounds & Parallax',
      description: 'Find the perfect backdrops for your ball physics simulations.',
      sections: [
        {
          id: 'background-selection',
          title: 'Choosing a Background',
          content: 'The background sets the mood for your entire simulation. From deep space nebulae to clean minimalist gradients, our library offers hundreds of options to complement your music.',
          settingId: 'background_picker_panel'
        },
        {
          id: 'parallax-effects',
          title: 'Depth with Parallax',
          content: 'Parallax layers move at different speeds, creating a 3D sense of depth. You can stack multiple effects like "Aurora Waves" or "Starfield" to create a complex, layered look.',
          settingId: 'parallax_settings_detail',
          tips: ['Try combining "VHS Glitch" with a low-opacity "Matrix Rain" for a retro-digital aesthetic.']
        }
      ]
    },
    {
      slug: 'visual-fx',
      title: 'Visual Effects & Eye Candy',
      description: 'Add trails, blasts, and impact particles to your simulation.',
      sections: [
        {
          id: 'ball-trails',
          title: 'Dynamic Ball Trails',
          content: 'Trails follow the path of your balls, emphasizing their movement. You can adjust the length, color, and "fade" of these trails to create light-painting effects.',
          settingId: 'trail_settings_config'
        },
        {
          id: 'impact-blasts',
          title: 'Impact & Collision Blasts',
          content: 'When balls collide with boundaries or each other, you can trigger visual "blasts". Choose from explosive shards, digital glitches, or soft glow pulses.',
          settingId: 'impact_fx_selection',
          tips: ['Match the blast color to the frequency of the audio trigger for the most satisfying sync.']
        }
      ]
    }
  ]
};
